// store/slices/orderSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import {
  getOrdersApi,
  getOrderDetailsApi
} from "../../api/orderApi"

////////////////////////////////////////////////////////
// FETCH ORDERS LIST
////////////////////////////////////////////////////////

export const fetchOrders = createAsyncThunk(
  "order/fetchOrders",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getOrdersApi()
      return res.data.data
    } catch (err) {
      return rejectWithValue(err.response?.data)
    }
  }
)

////////////////////////////////////////////////////////
// FETCH ORDER DETAILS
////////////////////////////////////////////////////////

export const fetchOrderDetails = createAsyncThunk(
  "order/fetchOrderDetails",
  async (data, { rejectWithValue }) => {
    try {
      const res = await getOrderDetailsApi(data)
      const order = res.data.data

      // ✅ KEEP ORIGINAL STRUCTURE (IMPORTANT)
      return {
        orderId: order.id,
        orderData: order
      }

    } catch (err) {
      return rejectWithValue(err.response?.data)
    }
  }
)

////////////////////////////////////////////////////////
// SLICE
////////////////////////////////////////////////////////

const orderSlice = createSlice({

  name: "order",

  initialState: {
    ordersById: {},
    orderIds: [],
    loading: false
  },

  reducers: {},

  extraReducers: builder => {

    builder

      /////////////////////////////////////////////////
      // LIST
      /////////////////////////////////////////////////

      .addCase(fetchOrders.pending, (state) => {
        state.loading = true
      })

      .addCase(fetchOrders.fulfilled, (state, action) => {

        state.loading = false

        const orders = action.payload

        const byId = {}
        const ids = []

        orders.forEach(order => {
          byId[order.id] = order
          ids.push(order.id)
        })

        state.ordersById = byId
        state.orderIds = ids
      })

      /////////////////////////////////////////////////
      // DETAILS
      /////////////////////////////////////////////////

      .addCase(fetchOrderDetails.pending, (state) => {
        state.loading = true
      })

      .addCase(fetchOrderDetails.fulfilled, (state, action) => {

        state.loading = false

        const { orderId, orderData } = action.payload

        // ✅ replace / update entry
        state.ordersById[orderId] = orderData

        if (!state.orderIds.includes(orderId)) {
          state.orderIds.push(orderId)
        }

      })

      .addCase(fetchOrderDetails.rejected, (state) => {
        state.loading = false
      })

  }

})

export default orderSlice.reducer